<p-popover #op (onHide)="onPopoverHide()">
  <div class="flex flex-col gap-4 min-w-[194px]">
    <div>
      <ul class="list-none p-0 m-0 flex flex-col">
        @for (option of options; track option.id) {
        <li
          class="flex items-center gap-2 px-2 py-3 hover:bg-[var(--bg-surface-hover)] cursor-pointer rounded-border"
          (click)="selectOption(option)"
        >
          <img [src]="'assets/icons/' + option.image" />
          <div>
            <span class="qbrain-text-base qbrain-text-primary">{{
              option.name
            }}</span>
          </div>
        </li>
        }
      </ul>
    </div>
  </div>
</p-popover>
